import { useEffect, useState } from "react";
import { MultiSelect, MultiSelectChangeEvent } from "primereact/multiselect";

import { useAppDispatch, useAppSelector } from "store/store";
import { inputSelectedItemsLabel, labelTopic } from "_constants";
import { setTopicSources } from "store/slicer/GestioneSourcesSlice";
import { getTopicListLite } from "services";
import { TopicLite } from "interfaces";
import { useUnmountEffect } from "primereact/hooks";

export const InputSourceTopic = () => {
  const [topicList, setTopicList] = useState<TopicLite[] | null>(null);
  const [selectedTopics, setSelectedTopics] = useState<TopicLite[] | null>(
    null
  );
  const filters = useAppSelector((state) => state.gestioneSourcesSlice.filters);

  const dispatch = useAppDispatch();

  const onChangeValue = (event: MultiSelectChangeEvent) => {
    if (event.value?.length) {
      setSelectedTopics(event.value);
      dispatch(setTopicSources(event.value?.map((topic: any) => topic.id)));
    } else {
      setSelectedTopics(event.value);

      dispatch(setTopicSources(null));
    }
  };

  useEffect(() => {
    getTopicListLite()
      .then((response) => {
        const topicIdList = filters.topicIdList;
        if (topicIdList) {
          setSelectedTopics(
            response.data.filter((el: any) => el.id === topicIdList)
          );
        }
        setTopicList(response.data);
      })
      .catch((_) => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useUnmountEffect(() => {
    dispatch(setTopicSources(null));
  });

  return (
    <MultiSelect
      value={selectedTopics}
      onChange={onChangeValue}
      options={topicList ?? []}
      optionLabel="name"
      filter
      placeholder={labelTopic}
      showClear={true}
      maxSelectedLabels={1}
      selectedItemsLabel={`${selectedTopics?.length?.toString()} ${inputSelectedItemsLabel}`}
      className="width-100"
    />
  );
};
